module.exports = __webpack_public_path__ + "img/careplan-logo-new.03fd7d4.png";